import React, { useState } from 'react';

const ExampleTemplateModal = ({ isOpen, onClose, onCopyToClipboard, onCreateTemplate }) => {
  const [expandedSections, setExpandedSections] = useState({});

  if (!isOpen) return null;

  const exampleTemplates = [
    {
      id: 1,
      title: "수업 결과 안내",
      content: `📘 금일 #{학생명}학생의 수업 결과 안내드립니다.

👩‍🏫 클래스 : #{반이름}
📅 날짜 : #{제출일}

아래 링크를 참고해주세요!
🔗 링크 : #{수업결과링크}`
    },
    {
      id: 2,
      title: "지필과제 채점 완료 시 알림",
      content: `✅ #{학생명}학생의 지필 과제가 #{제출일} 채점완료 되었습니다.

👩‍🏫 클래스 : #{반이름}
📑 시험지 유형 : #{시험지유형}
📝 과제명 : #{과제명}
🎯 점수 : #{점수}
📄 첨삭결과 : #{과제리포트주소}

👉 위의 첨삭결과 링크를 클릭하시면, #{학생명}학생이 제출한 정답과 오답을 확인하실 수 있습니다.`
    },
    {
      id: 3,
      title: "알림장 - 수업 내용 및 시험 결과 안내",
      content: `📘 금일 #{학생명}학생의 수업 결과 안내드립니다.

👩‍🏫 클래스 : #{반이름}
📅 날짜 : #{제출일}

📖 수업 내용
#{수업내용}

🎯 시험 결과
#{시험점수}

📝 과제 점수
#{과제점수}

💬 특이사항
#{알림장내용}

🔗 상세 내용 : #{수업결과링크}`
    }
  ];

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  return (
    <div 
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: "white",
          borderRadius: "12px",
          width: "90%",
          maxWidth: "900px",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.3)"
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 24px",
          borderBottom: "1px solid #e9ecef",
          background: "#f8f9fa",
          borderRadius: "12px 12px 0 0"
        }}>
          <h3 style={{ margin: "0", fontSize: "18px", color: "#333", fontWeight: "600" }}>
            📝 예시 템플릿
          </h3>
          <button 
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#666",
              padding: "4px",
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
              transition: "all 0.2s"
            }}
            onMouseOver={(e) => {
              e.target.style.background = "rgba(0, 0, 0, 0.1)";
              e.target.style.color = "#333";
            }}
            onMouseOut={(e) => {
              e.target.style.background = "none";
              e.target.style.color = "#666";
            }}
          >
            ×
          </button>
        </div>
        
        <div style={{ padding: "24px" }}>
          <p style={{ marginBottom: "16px", color: "#666" }}>
            아래 템플릿들을 참고하여 센드온에서 템플릿을 생성해주세요.
          </p>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {exampleTemplates.map(template => (
              <div key={template.id} style={{
                border: "1px solid #e9ecef",
                borderRadius: "8px",
                overflow: "hidden"
              }}>
                <div 
                  style={{
                    padding: "16px 20px",
                    background: "#f8f9fa",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #e9ecef",
                    transition: "background-color 0.2s"
                  }}
                  onClick={() => toggleSection(template.id)}
                  onMouseOver={(e) => e.target.style.background = "#e9ecef"}
                  onMouseOut={(e) => e.target.style.background = "#f8f9fa"}
                >
                  <h4 style={{ margin: "0", fontSize: "16px", fontWeight: "600", color: "#333" }}>
                    {template.id}. {template.title}
                  </h4>
                  <span style={{
                    fontSize: "12px",
                    transition: "transform 0.2s",
                    color: "#666",
                    transform: expandedSections[template.id] ? "rotate(180deg)" : "rotate(0deg)"
                  }}>
                    ▼
                  </span>
                </div>
                
                {expandedSections[template.id] && (
                  <div style={{ padding: "20px" }}>
                    <div style={{
                      background: "#f8f9fa",
                      border: "1px solid #e9ecef",
                      borderRadius: "6px",
                      padding: "16px",
                      marginBottom: "16px"
                    }}>
                      <pre style={{
                        margin: "0",
                        whiteSpace: "pre-wrap",
                        wordWrap: "break-word",
                        fontFamily: "'Courier New', monospace",
                        fontSize: "14px",
                        lineHeight: "1.6",
                        color: "#333"
                      }}>
                        {template.content}
                      </pre>
                    </div>
                    <div style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "12px",
                      flexWrap: "wrap"
                    }}>
                      <button
                        onClick={() => onCopyToClipboard(template.content)}
                        style={{
                          padding: "8px 16px",
                          border: "none",
                          borderRadius: "4px",
                          fontSize: "14px",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          fontWeight: "500",
                          background: "#28a745",
                          color: "white"
                        }}
                        onMouseOver={(e) => e.target.style.background = "#218838"}
                        onMouseOut={(e) => e.target.style.background = "#28a745"}
                      >
                        📋 복사하기
                      </button>
                      <button
                        onClick={() => onCreateTemplate(template)}
                        style={{
                          padding: "8px 16px",
                          border: "none",
                          borderRadius: "4px",
                          fontSize: "14px",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          fontWeight: "500",
                          background: "#007bff",
                          color: "white"
                        }}
                        onMouseOver={(e) => e.target.style.background = "#0056b3"}
                        onMouseOut={(e) => e.target.style.background = "#007bff"}
                      >
                        🚀 센드온에 템플릿 간편 생성하기
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExampleTemplateModal;
